export const API_ENDPOINTS = {
  ACCOUNTS: {
    LOGIN: "accounts/login/",
    LOGOUT: "accounts/logout/",
    SIGNUP: "accounts/platform-employee/signup/",
    PROFILE: "accounts/profile/",
    PROTECTED: "accounts/protected/",
    CHANGE_PIN: "accounts/change-pin/",
    FORGOT_PIN: "accounts/forgot-pin/",
    REQUEST_OTP: "accounts/request-otp/",
    VERIFY_OTP: "accounts/verify-otp/",
    TOKEN_REFRESH: "accounts/token/refresh/",
    INVOICE_REQUEST: "accounts/invoice/request/",
    INVOICE_GET: "accounts/invoice/get/",
    INVOICE_LIST: "accounts/invoice/list/",
    USER_SUBSCRIPTION_COUNT: "accounts/user/subscription/count/",
    STATES: "accounts/states/",
    DISTRICTS: (stateId) => `accounts/districts/${stateId}/`,
  },

  SELLERS: {
    BUYER_LIST: "sellers/buyer/list/",
    PROFILE: "sellers/profile/",
    PROFILE_BY_ID: (sellerId) => `sellers/profile/${sellerId}/`,
    PROFILE_ACTIVE_STATUS: (sellerId) =>
      `sellers/profile/${sellerId}/activestatus/`,
    PROFILE_CHANGE_IMAGE: "sellers/profile/changeimage/",
    PROFILE_DELETE: "sellers/profile/delete/",
    PROFILE_UPDATE: (sellerId) => `sellers/profile/${sellerId}/update/`,
    CATALOGS: "sellers/catalogs/",
    CATALOGS_BY_SELLER: (sellerId) => `sellers/catalogs/${sellerId}/`,
    CATALOGS_DELETE: (catalogId) => `sellers/catalogs/${catalogId}/delete/`,
    CATALOGS_UPLOAD: "sellers/catalogs/upload/",
    CATALOGS_CHUNK_UPLOAD: "sellers/catalogs/upload/",
    CATALOGS_USED_STORAGE: "sellers/profile/catalogs-used-storage/",
    SOCIAL_SELLER_REVIEW_BY_SELLER: (sellerId) =>
      `social/sellers/${sellerId}/reviews/list/`,
    SOCIAL_SELLER_REVIEW_DELETE: (reviewId) =>
      `social/reviews/${reviewId}/delete/`,
    CATEGORY_LIST: "sellers/category/list/",
    SIGNUP: "sellers/signup/",
    TILE_INQUIRY_CLICK_LIST: "sellers/tile-product/inquiry-click/list/",
    SANITARYWARE_INQUIRY_CLICK_LIST: "sellers/sanitaryware-product/inquiry-click/list/",
  },

  BUYERS: {
    SIGNUP: "buyers/signup/",
    PROFILE: "buyers/profile/",
    PROFILE_BY_ID: (buyerId) => `buyers/profile/${buyerId}/`,
    PROFILE_UPDATE: "buyers/profile/update/",
    PROFILE_DELETE: "buyers/profile/delete/",
    PROFILE_CHANGE_IMAGE: "buyers/profile/changeimage/",
    INQUIRY_LIST: "buyers/inquiry/list/",
    INQUIRY_SUBMIT: "buyers/inquiry/submit/",
    INTERESTS_GET: "buyers/interests/get/",
    INTERESTS_OPTIONS: "buyers/interests/options/",
    INTERESTS_SUBMIT: "buyers/interests/submit/",
    SANITARYWARE_INQUIRY_CLICK: (productId) =>
      `buyers/sanitaryware-product/${productId}/inquiry-click/`,
    TILE_INQUIRY_CLICK: (productId) =>
      `buyers/tile-product/${productId}/inquiry-click/`,
    SANITARYWARE_INQUIRY_CLICK_LIST:
      "accounts/sanitaryware-product/inquiry-click/list/",
    TILE_INQUIRY_CLICK_LIST: "accounts/tile-product/inquiry-click/list/",
  },

  SANITARYWARE: {
    LIST: "products/sanitaryware/list/",
    CREATE: "products/sanitaryware/create/",
    DETAIL: (id) => `products/sanitaryware/${id}/detail/`,
    UPDATE: (id) => `products/sanitaryware/${id}/update/`,
    DELETE: (id) => `products/sanitaryware/${id}/delete/`,
    ACTIVATION_STATUS: (productId) =>
      `products/sanitaryware/${productId}/activation-status/`,
    PUBLISH_STATUS: (productId) =>
      `products/sanitaryware/${productId}/publish-status/`,
    IMAGES_LIST: (productId) =>
      `products/sanitaryware/${productId}/images/list/`,
    IMAGES_UPLOAD: (productId) =>
      `products/sanitaryware/${productId}/images/upload/`,
    IMAGES_DETAIL: (productId, imageId) =>
      `products/sanitaryware/${productId}/images/detail/${imageId}/`,
    IMAGES_DELETE: (productId, imageId) =>
      `products/sanitaryware/${productId}/images/delete/${imageId}/`,
    IMAGES_CHANGE_PRIMARY: (productId, imageId) =>
      `products/sanitaryware/${productId}/images/change-primary/${imageId}/`,
    ATTRIBUTES_LIST: "products/sanitaryware/attributes/list/",
    ATTRIBUTES_CREATE: "products/sanitaryware/attributes/create/",
    ATTRIBUTES_DETAIL: (attrId) =>
      `products/sanitaryware/attributes/${attrId}/detail/`,
    ATTRIBUTES_UPDATE: (attrId) =>
      `products/sanitaryware/attributes/${attrId}/update/`,
    ATTRIBUTES_DELETE: (attrId) =>
      `products/sanitaryware/attributes/${attrId}/delete/`,
    ATTRIBUTES_PREVIEW_UPDATE: (attrId) =>
      `products/sanitaryware/attributes/${attrId}/preview-update/`,
    ATTRIBUTES_UNDO_DEPRECATION: (attrId) =>
      `products/sanitaryware/attributes/${attrId}/undo-deprecation/`,
    TYPES_LIST: "products/sanitaryware/types/list/",
    TYPES_CREATE: "products/sanitaryware/types/create/",
    TYPES_UPDATE: (typeId) => `products/sanitaryware/types/${typeId}/update/`,
    TYPES_DELETE: (typeId) => `products/sanitaryware/types/${typeId}/delete/`,
    TYPES_UNDO_DEPRECATION: (typeId) =>
      `products/sanitaryware/types/${typeId}/undo-deprecation/`,
    TYPES_ASSIGN_ATTRIBUTE: (typeId) =>
      `products/sanitaryware/types/${typeId}/assign-attribute/`,
    TYPES_REMOVE_ATTRIBUTE: (typeId) =>
      `products/sanitaryware/types/${typeId}/remove-attribute/`,
    TYPES_FILTERS: (typeId) => `products/sanitaryware/types/${typeId}/filters/`,
    PDFS_LIST: (productId) => `products/sanitaryware/${productId}/pdfs/list/`,
    PDFS_UPLOAD: (productId) => `products/sanitaryware/${productId}/pdfs/upload/`,
    PDFS_DELETE: (productId, pdfId) =>
      `products/sanitaryware/${productId}/pdfs/delete/${pdfId}/`,
    PDFS_DETAIL: (productId, pdfId) =>
      `products/sanitaryware/${productId}/pdfs/${pdfId}/detail/`,
    PDFS_REPLACE: (productId, pdfId) =>
      `products/sanitaryware/${productId}/pdfs/${pdfId}/replaced/`,
  },

  TILES: {
    LIST: "products/tiles/list/",
    CREATE: "products/tiles/create/",
    DETAIL: (id) => `products/tiles/${id}/detail/`,
    UPDATE: (id) => `products/tiles/${id}/update/`,
    DELETE: (id) => `products/tiles/${id}/delete/`,
    ACTIVATION_STATUS: (productId) =>
      `products/tiles/${productId}/activation-status/`,
    PUBLISH_STATUS: (productId) =>
      `products/tiles/${productId}/publish-status/`,
    PDFS_LIST: (productId) => `products/tiles/${productId}/pdfs/list/`,
    PDFS_UPLOAD: (productId) => `products/tiles/${productId}/pdfs/upload/`,
    PDFS_DELETE: (productId, pdfId) =>
      `products/tiles/${productId}/pdfs/delete/${pdfId}/`,
    PDFS_DETAIL: (productId, pdfId) =>
      `products/tiles/${productId}/pdfs/${pdfId}/detail/`,
    PDFS_REPLACE: (productId, pdfId) =>
      `products/tiles/${productId}/pdfs/${pdfId}/replaced/`,
    LINKS_ADD_UPDATE: (productId) =>
      `products/tiles/${productId}/addupdatelink/`,
    LINKS_DELETE: (productId) =>
      `products/tiles/${productId}/deletelink/`,
    SIZES_LIST: "products/tiles/sizes/list/",
    SIZES_CREATE: "products/tiles/sizes/create/",
    SIZES_UPDATE: (sizeId) => `products/tiles/sizes/${sizeId}/update/`,
    SIZES_DELETE: (sizeId) => `products/tiles/sizes/${sizeId}/delete/`,
    SIZES_UNDO_DEPRECATION: (sizeId) =>
      `products/tiles/sizes/${sizeId}/undo-deprecation/`,
    TYPES_LIST: "products/tiles/types/list/",
    TYPES_CREATE: "products/tiles/types/create/",
    TYPES_UPDATE: (typeId) => `products/tiles/types/${typeId}/update/`,
    TYPES_DELETE: (typeId) => `products/tiles/types/${typeId}/delete/`,
    TYPES_UNDO_DEPRECATION: (typeId) =>
      `products/tiles/types/${typeId}/undo-deprecation/`,
  },

  SOCIAL_POSTS: {
    LIST: "social/post/list/",
    CREATE: "social/post/create/",
    DETAIL: (postId) => `social/post/${postId}/detail/`,
    UPDATE: (postId) => `social/post/${postId}/update/`,
    DELETE: (postId) => `social/post/${postId}/delete/`,
  },

  SUBSCRIPTIONS: {
    LIST: "subscriptions/plans/",
    CREATE: "subscriptions/create/",
    PAYMENT_INITIATE: "subscriptions/payment/initiate/",
    PAYMENT_VERIFY: "subscriptions/payment/verify/",
    PLANS_LIST: "subscriptions/plans/",
    PLAN_DETAIL: (id) => `subscriptions/plans/${id}/`,
    PLAN_UPDATE: (id) => `subscriptions/plans/${id}/`,
    PLAN_DELETE: (id) => `subscriptions/plans/${id}/`,
    PLAN_CREATE: "subscriptions/plans/create/",
    SELLER_SUBSCRIPTION: "subscriptions/sellers/",
    SELLER_SUBSCRIPTION_BY_ID: (id) => `subscriptions/sellers/${id}/`,
  },
};

export const buildApiUrl = (endpoint) => {
  const baseUrl =
    process.env.REACT_APP_API_BASE_URL ||
    "https://dev.api.morbibazaar.com/api/v1/";
  return `${baseUrl}${endpoint}`;
};

export const getEndpoint = (endpoint, ...params) => {
  if (typeof endpoint === "function") {
    return endpoint(...params);
  }
  return endpoint;
};

export const getQueryEndpoint = (endpoint, params = {}) => {
  let url = typeof endpoint === "function" ? endpoint() : endpoint;
  const queryString = new URLSearchParams(params).toString();
  if (queryString) {
    url += (url.includes("?") ? "&" : "?") + queryString;
  }
  return url;
};

export default API_ENDPOINTS;
